import qs from "qs";
import {apiVoissa, apiVoissaNoError} from "../../libs/api";
import { insertAtRandomIndexes, probability } from "../../libs/helper";

export const fetchHomeProfilesSuggest = (query = {}, config = {}) => apiVoissa.get(`/home-suggest?${qs.stringify(query)}`, config);

export const fetchHomeFeed = async (kind, user, query = {}, config = {}) => {
    const feedKind = ['popular', 'recent', 'for-you'].includes(kind) ? kind : `popular`;
    const adsLimit = probability(50) ? 1 : 0;
    const feedData = await apiVoissa.get(`/home-feed/${feedKind}?${qs.stringify(query)}`, config);
   
    if(adsLimit && feedData.data.length && !user){
        try {
            const ads = await apiVoissaNoError.get(`/bananas-service/bananas?${qs.stringify({source:"FEED", limit: adsLimit})}`);
            feedData.data = insertAtRandomIndexes(feedData.data, ads.data.map(ad=>({publicationType : 'Ad', ...ad})));
        }
        catch (e) {
            console.error('unable to fetch ads', e);
        }
    }
    return feedData;
}

export const HOME_FEED_KEY = `home-feed`;
export const HOME_FEED_MEDIAS_KEY = `home-feed-medias`;
export const HOME_FEED_FOR_YOU_KEY = `home-feed-for-you`;
export const HOME_PROFILES_SUGGEST_KEY = `home-profiles-suggest`;
